import ClickableIcon from '@/shared/Common/ClickableIcon'
import PlayIcon from '@/assets/icons/play-line.svg?react'
import { MouseEvent } from 'react'

interface IProps {
  size: 'default'
  onClick: (ev: MouseEvent<HTMLDivElement>) => void
}

const PlayButton = (props: IProps) => {
  return <ClickableIcon icon={PlayIcon} size={props.size} onClick={props.onClick} />
}

export default PlayButton
